export default function MacroBar({ label, value, goal, color, unit = 'g' }) {
  const pct  = Math.min((value / goal) * 100, 100);
  const over = value > goal;

  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between',
        fontSize: 13, marginBottom: 6 }}>
        <span style={{ color: 'rgba(255,255,255,0.7)' }}>{label}</span>
        <span style={{ fontWeight: 700, color: over ? '#ff6b6b' : '#fff' }}>
          {Math.round(value)}{unit} <span style={{ color: 'rgba(255,255,255,0.4)', fontWeight: 400 }}>/ {goal}{unit}</span>
        </span>
      </div>
      <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 999, height: 8, overflow: 'hidden' }}>
        <div style={{
          width: `${pct}%`,
          background: over
            ? 'linear-gradient(90deg, #ff6b6b, #ee5a24)'
            : `linear-gradient(90deg, ${color}, ${color}cc)`,
          borderRadius: 999, height: 8,
          transition: 'width 0.5s cubic-bezier(0.4,0,0.2,1)',
          boxShadow: `0 0 8px ${color}66`,
        }} />
      </div>
    </div>
  );
}